<template>
  <div class="footer">
    <div class="flex flexb">
      <div class="pct40">
        <img src="@/assets/images/logo.png" width="100%">
        <div class="mt10">
          <div class="f14">{{language == 'EN'?'Contact Number':'联系电话'}}</div>
          <div class="f14 fb dblue mt3">{{footer.phone.info}}</div>
        </div>
      </div>

      <div class="pct55 f12 lh20">
        {{footer.address.title}}：{{footer.address.info}}<br>
        {{footer.fax.title}}：{{footer.fax.info}}　<br>
        {{footer.email.title}}：{{footer.email.info}}
        
        <!--
        {{language == 'EN'?'Address：LongShanShaAo Village, Liuheng Island, Zhoushan City':'地址：舟山市普陀区六横镇龙山沙岙村'}}　<br>
        {{language == 'EN'?'Fax':'传真'}}：0086-580-6688098<br>
        {{language == 'EN'?'E-mail':'邮箱'}}：Business@Ls-shipyard.com
        -->
      </div>
    </div>

    <div class="mt15 f12 tc">
      {{footer.copyright.info}}
      <a target="_blank" href="https://beian.miit.gov.cn/">浙ICP备11005702号-1</a>
    </div>

  </div>
</template>

<script>
import {getCompanyConfig} from "@/request/api";
export default {
  name: 'Footer',
  data () {
    return {
      language:localStorage.getItem('language') || 'CH',
      footer:[],
    }
  },
  created (){
    this.getFooter()
  },
  methods:{
    getFooter(){
      var that = this
      getCompanyConfig().then(res=>{
        that.footer = res.data
      }).catch(function (error) {
          console.log(error);
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer{
  width: 100%;
  padding: 20px 10px;
  background: #fff url(../assets/images/bg_bot.png) no-repeat bottom center;
  background-size: cover;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterM.vue